'use client';

import { faChevronLeft, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRef, useState, type ReactNode } from "react";
import Slider, { type Settings } from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { Carousel, CarouselContent, CarouselNext, CarouselPrevious } from '../Carousel';

export default function ScrollBox({
    children,
    slidesToShowSmall = 2,
    slidesToShowLarge = 4,
}: {
    children: ReactNode[] | ReactNode;
    slidesToShowSmall?: number;
    slidesToShowLarge?: number;
}) {



    return (
        <div className="h-full w-full relative overflow-visible">
            {/* Small screens: horizontal scroll */}
            <div className="overflow-x-auto md:hidden flex px-1 space-x-2 relative pb-4">
                {children}
            </div>

            {/* Medium and up: Slider */}
            <div className="hidden md:block relative">
                <Carousel className="w-full">
                    <CarouselNext />
                    <CarouselPrevious />
                    <CarouselContent>
                        {children}
                    </CarouselContent>
                </Carousel>
            </div>
        </div>
    );
}
